import React, { createContext, useContext } from 'react';
const HeadingContext = /*#__PURE__*/createContext(undefined);
export const useHeadingElement = () => {
  return Math.min(useContext(HeadingContext) || 0, 6);
};
/**
 * __Heading context__
 *
 * The HeadingContext
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */
const HeadingContextProvider = ({
  children,
  value
}) => {
  const parentHeadingLevel = useHeadingElement();
  const headingLevel = parentHeadingLevel + 1;
  return /*#__PURE__*/React.createElement(HeadingContext.Provider, {
    value: value || headingLevel
  }, children);
};
export default HeadingContextProvider;